import * as React from 'react';
import { Layout } from 'react-admin';
import CustomMenu from './menu';

const CustomLayout = (props) => <Layout menu={CustomMenu} {...props} />;

export default CustomLayout;